"use client";




export default function Hero() {
  return (
    <section className="flex items-center w-full relative z-10 py-36">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-[-1]">
        <img
          src="/images/cfc096485619d7063ebe1e919483a1de.png"
          className="h-full w-full object-cover object-top"
          width={2250}
          height={1500}
          fetchPriority="high"
          loading="eager"
        />

        {/* Overlay with gradient on larger screens */}
        <div
          className="absolute inset-0 bg-black/40 dark:bg-background/70"
          aria-hidden="true"
        />
      </div>
      {/* Content Container */}
      <div className="flex flex-col items-center w-full pt-20">
        <div className="max-w-7xl w-full flex flex-col items-center text-center lg:items-start lg:text-left">
          {/* Title */}
          <h1 className="mb-4 text-[2.5rem] font-bold leading-tight text-white lg:text-[3.8rem]">
            Make your project a reality
            <br />
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-white to-primary">
              with Bishop Mercier
            </span>
          </h1>

          {/* Description */}
          <p className="mb-10 max-w-[35rem] text-base text-white/70 lg:text-xl">
            Trusted construction experts for residential, commercial, and
            industrial projects throughout Montreal. Based in Westmount.
          </p>

          {/* CTA Buttons */}
          <div className="max-lg:px-8 flex flex-col items-center gap-3 md:flex-row sm:gap-4 w-full sm:w-auto justify-center lg:justify-start">
            <a
              href="/contact"
              className="w-fit flex justify-center items-center rounded-md bg-primary px-6 py-3 font-bold text-primary-foreground transition-colors hover:bg-primary/90"
            >
              GET A FREE QUOTE
            </a>
            <a
              href="/portfolio"
              className="w-fit flex justify-center items-center rounded-md bg-white px-6 py-3 font-bold text-primary border border-primary transition-colors hover:bg-muted"
            >
              SEE OUR PORTFOLIO
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
